import React from 'react';

export default function Divider(){
  return <div style={{width: '100%', height: 1, backgroundColor: '#F1F1F1', margin: '15px 0px'}}></div>
}